import { Controller } from "@hotwired/stimulus"

const STATE_SPLIT = "split"
const STATE_DOCUMENTS_EXPANDED = "documentsExpanded"
const STATE_DETAILS_EXPANDED = "detailsExpanded"

export default class extends Controller {
  static targets = [
    "documentsColumn",
    "detailsColumn",
    "expandDocumentsLink",
    "collapseDocumentsLink",
    "expandDetailsLink",
    "collapseDetailsLink",
    "divider",
  ]
  static values = { hasDocuments: Boolean }

  connect() {
    // If the documents column was rendered hidden (no documents present),
    // treat the initial state as the details panel being fully expanded so
    // the collapse link is available to bring documents back into view.
    const initialState = this.documentsColumnTarget.classList.contains("hidden")
      ? STATE_DETAILS_EXPANDED
      : STATE_SPLIT
    this._setState(initialState)
  }

  expandDocuments(event) {
    event.preventDefault()
    this._setState(STATE_DOCUMENTS_EXPANDED)
  }

  expandDetails(event) {
    event.preventDefault()
    this._setState(STATE_DETAILS_EXPANDED)
  }

  restore(event) {
    event.preventDefault()
    this._setState(STATE_SPLIT)
  }

  _setState(state) {
    // The documents column's width is the reviewer's to set (the divider, split-view controller),
    // so this controller never writes it. Expanding the documents overrides it with a flex-basis
    // instead, and clearing that brings the reviewer's split back. That also holds for a page
    // restored from Turbo's cache in an expanded state, which reconnects here as split.
    switch (state) {
      case STATE_DOCUMENTS_EXPANDED:
        this.documentsColumnTarget.classList.remove("hidden")
        this.documentsColumnTarget.style.display = "block"
        this.documentsColumnTarget.style.flexBasis = "100%"
        this.detailsColumnTarget.style.display = "none"
        break
      case STATE_DETAILS_EXPANDED:
        this.documentsColumnTarget.style.display = "none"
        this.detailsColumnTarget.style.display = "flex"
        this.detailsColumnTarget.style.width = "100%"
        break
      default:
        this.documentsColumnTarget.classList.remove("hidden")
        this.documentsColumnTarget.style.display = "block"
        this.documentsColumnTarget.style.flexBasis = ""
        this.detailsColumnTarget.style.display = "flex"
        this.detailsColumnTarget.style.width = "auto"
        break
    }
    this._updateLinkVisibility(state)
  }

  _updateLinkVisibility(state) {
    if (this.hasDividerTarget) {
      this.dividerTarget.classList.toggle("hidden", state !== STATE_SPLIT)
    }
    if (this.hasExpandDocumentsLinkTarget) {
      this.expandDocumentsLinkTarget.classList.toggle("hidden", state !== STATE_SPLIT)
    }
    if (this.hasCollapseDocumentsLinkTarget) {
      this.collapseDocumentsLinkTarget.classList.toggle("hidden", state !== STATE_DOCUMENTS_EXPANDED)
    }
    if (this.hasExpandDetailsLinkTarget) {
      this.expandDetailsLinkTarget.classList.toggle("hidden", state !== STATE_SPLIT)
    }
    if (this.hasCollapseDetailsLinkTarget) {
      this.collapseDetailsLinkTarget.classList.toggle("hidden", state !== STATE_DETAILS_EXPANDED)
    }
  }
}
